<div class="contents">
  <div class="page-header">
    <div class="left-area">
      <span class="title">Configurações</span>
      <span class="sub-title">Escolha uma área para configurar</span>
    </div>
  </div>

  <div class="settings-hub-grid">
    <ng-container *ngFor="let item of items">
      <div class="settings-card" *appHasAnyRole="item.permissoes" (click)="open(item)">
        <div class="icon">
          <img [src]="item.icone" alt="" />
        </div>
        <div class="details">
          <h3>{{ item.titulo }}</h3>
          <p>{{ item.descricao }}</p>
        </div>
        <i class="pi pi-angle-right chevron"></i>
      </div>
    </ng-container>
  </div>
</div>
